import axios from 'axios'
import { call, put, select, takeEvery, takeLatest, delay } from 'redux-saga/effects'
import { PAM_API } from 'constants/url'
import { fromIdentity } from 'store/selectors'
import { toast } from 'react-toastify'
import intl from 'react-intl-universal'
import * as actions from './actions'

export function* getAttributes() {
  yield delay(300)
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.get, `${PAM_API}/api/attributes`, {
      headers: {
        authenticateit_identity_ticket: ticket
      }
    })

    yield put(actions.pamGetAttributesSuccess(data))
  } catch (error) {
    yield put(actions.pamGetAttributesFail(error))
  }
}

export function* updateAttribute({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.patch, `${PAM_API}/api/attributes`, payload, {
      headers: {
        authenticateit_identity_ticket: ticket
      }
    })

    if (data.result === 'Attribute updated') {
      yield put(actions.pamUpdateAttributeSuccess())
      toast.success(intl.get('alerts.updateAttributeSuccess', { name: payload.name }))
      yield put(actions.pamGetAttributes())
      return
    }

    toast.error(intl.get('alerts.updateAttributeFail'))
    yield put(actions.pamUpdateAttributeFail())
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      toast.error(`${error.response.data.error}` || intl.get('alerts.updateAttributeFail'))
    } else {
      toast.error(intl.get('alerts.updateAttributeFail'))
    }

    yield put(actions.pamUpdateAttributeFail(error))
  }
}

export function* addAttribute({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.post, `${PAM_API}/api/attributes`, payload, {
      headers: {
        authenticateit_identity_ticket: ticket
      }
    })

    if (data.result === 'Attribute added') {
      yield put(actions.pamAddAttributeSuccess())
      toast.success(intl.get('alerts.addAttributeSuccess', { name: payload.name }))
      yield put(actions.pamGetAttributes())
      return
    }

    toast.error(intl.get('alerts.addAttributeFail'))
    yield put(actions.pamAddAttributeFail())
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      toast.error(`${error.response.data.error}`)
    } else {
      toast.error(intl.get('alerts.addAttributeFail'))
    }

    yield put(actions.pamAddAttributeFail(error))
  }
}

export function* deleteAttribute({ payload }) {
  try {
    const ticket = yield select(fromIdentity.getTicket)

    const { data } = yield call(axios.delete, `${PAM_API}/api/attributes`, {
      headers: {
        authenticateit_identity_ticket: ticket
      },
      data: {
        id: payload.id
      }
    })

    if (data.result === 'Attribute deleted') {
      yield put(actions.pamDeleteAttributeSuccess())
      toast.success(intl.get('alerts.deleteAttrbiuteSuccess', { name: payload.name }))
      yield put(actions.pamGetAttributes())
      return
    }

    toast.error(intl.get('alerts.deleteAttrbiuteFail'))
    yield put(actions.pamDeleteAttributeFail())
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      toast.error(`${error.response.data.error}`)
    } else {
      toast.error(intl.get('alerts.deleteAttrbiuteFail'))
    }

    yield put(actions.pamDeleteAttributeFail(error))
  }
}

export default function*() {
  yield takeLatest(actions.GET_ATTRIBUTES, getAttributes)
  yield takeEvery(actions.UPDATE_ATTRIBUTE, updateAttribute)
  yield takeEvery(actions.ADD_ATTRIBUTE, addAttribute)
  yield takeEvery(actions.DELETE_ATTRIBUTE, deleteAttribute)
}
